import { PaginatedResponse } from "@utils/types/main";
import axiosInstance from "./index.services";
import { CricketTeamType } from "@pages/dashboard/marketingEvents/cricket/teams/column/index.column";

export async function CricketTeamFetch() {
  const res = await axiosInstance.get<PaginatedResponse<CricketTeamType>>(
    `/cricket-team/`
  );
  return res?.data;
}

export async function CricketTeamPost(data: any) {
  return await axiosInstance.post(`/cricket-team/`, data);
}

export async function CricketTeamUpdate(id: any, data: any) {
  return await axiosInstance.patch(`/cricket-team/${id}/`, data);
}

export async function CricketTeamDelete(id: any) {
  return await axiosInstance.delete(`/cricket-team/${id}/`);
}
